import { ExecutionResults, PostExecutionResults } from 'api/Exec/types';
import ExecutionResultsForm from 'app/common_components/ModelExecutionResults/ExecutionResultsForm/ExecutionResultsForm';
import PostExecutionResultsForm from 'app/common_components/ModelExecutionResults/PostExecutionResultsForm/PostExecutionResultsForm';

import React from 'react';
import { Flex } from 'antd';

interface Props {
  executionResults: ExecutionResults | null;
  postExecutionResults: PostExecutionResults | null;
  viewMode?: boolean;
}

const ModelExecutionResults: React.FC<Props> = ({ executionResults, postExecutionResults, viewMode = false }) => {
  return (
    <Flex gap={20} style={{ marginTop: 20 }}>
      <ExecutionResultsForm results={executionResults} viewMode={viewMode} />
      <PostExecutionResultsForm results={postExecutionResults} viewMode={viewMode} />
    </Flex>
  );
};

export default ModelExecutionResults;
